<div class="get-care-now-title-container-mobile">{{title}}</div>
<div class="get-care-now-description-container-mobile">
    <div>{{description}}</div>
</div>
<div  *ngIf="quickCareOptions != null && quickCareOptions.length > 0" class="get-care-now-scroll-container-mobile">
    <app-ask-a-doctor-option-card-mobile
      *ngFor="let option of quickCareOptions; let i = index"
      [title]="option.name"
      [waitTime]="option.waitTime"
      [photoUrl]="option.photoURL"
      [deepLink]="option.deeplink"
      [deepLinkNoAuth]="option.deepLinkNoAuth"
      [symptomID]="option.symptomID"
      [isPlus]="isPlus"
      [locale]="locale"
      [ngStyle]="i === 0 ? {'margin-left': '16px'} : null">
    </app-ask-a-doctor-option-card-mobile>
    <div>
        <mat-card class="get-care-now-show-more-card-mobile" appearance="outlined" style="text-align: center;" (click)="showMeMore()">
            <div class="get-care-now-show-more-button-mobile">{{showMoreText}}</div>
        </mat-card>
    </div>
</div>
<div *ngIf="!quickCareOptions || quickCareOptions.length === 0" style="width: 190px; height:190px; margin-top: 16px; margin-left: 16px;">
    <ng-container>
        <div class="get-care-now-loading-spinner-mobile">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>

